// extracted by mini-css-extract-plugin
export var buttons = "lpSimpleBlocStyles-module--buttons--c1589";
export var buttons_link = "lpSimpleBlocStyles-module--buttons_link--433fd";
export var container = "lpSimpleBlocStyles-module--container--65926";
export var content = "lpSimpleBlocStyles-module--content--9330b";
export var content_subtitle = "lpSimpleBlocStyles-module--content_subtitle--0003c";
export var content_title = "lpSimpleBlocStyles-module--content_title--b88b4";
export var pdp = "lpSimpleBlocStyles-module--pdp--535ca";